<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-card-title.title.caption--text {{title}}
            v-container(tag="v-card-text" gris-list-xl)
                v-form(id="form_kjdfOewrnf8" ref="refForm" @submit="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12)
                            v-text-field(v-model="name" ref="refName"
                                :placeholder="placeHolder" counter=100
                                :rules="[rules.required, rules.maxLength(name, 100)]")
                        v-flex(xs12 v-if="mode === 'edit'")
                            v-radio-group(v-model="status" :mandatory="false" row)
                                v-radio(:label="$t(`pages.settings.company.table.headers.status.values.false`)" color="red" :value="false")
                                v-radio(:label="$t(`pages.settings.company.table.headers.status.values.true`)" color="green" :value="true")
                                template(#prepend)
                                    .body-1 {{$t('pages.settings.company.table.headers.status.title')}}
            v-card-actions
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(type="submit" form="form_kjdfOewrnf8" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";

export default {
  name: "EditDialog",
  mixins: [rules, general, crud],
  data() {
    return {
      mode: "create",
      dialog: false,
      currentId: null,
      name: "",
      status: true,
      type: "companyType"
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    title: {
      get() {
        return this.$t(
          `pages.settings.system.dialog.${this.type}.title.${this.mode}`
        );
      }
    },
    placeHolder: {
      get() {
        return this.$t(`pages.settings.system.dialog.${this.type}.placeFolder`);
      }
    }
  },
  methods: {
    clear() {
      this.name = "";
      this.status = true;
    },
    show(mode, type, data = null) {
      this.clear();
      this.mode = mode;
      this.type = type;
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["refName"].resetValidation();
        if (mode === "edit" && data) {
          this.currentId = data.id;
          this.name = data.name;
          this.status = data.status;
        }
        setTimeout(() => {
          this.$refs["refName"].focus();
          // this.$refs['refName'].$el.select();
        }, 100);
      });
    },
    close() {
      this.dialog = false;
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.$refs["refForm"].validate()) {
        this.$confirm(this.$t("messages.saveConfirmation")).then(value => {
          if (value) {
            this.close();
            this.$emit("save", {
              mode: this.mode,
              id: this.currentId,
              type: this.type,
              body: {
                name: this.name,
                status: this.status
              }
            });
          }
        });
      }
    }
  }
};
</script>
